module.exports = "//public.zight.com/packs/media/images/logos-cloud-app-logomark-full-color-fa855f2a995fed9f7aad4a15df5071ea.svg";